import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Animate from 'grommet/components/Animate';
import FormUp from 'grommet/components/icons/base/FormUp';
import FormDown from 'grommet/components/icons/base/FormDown';
import { _said } from '../../SizerUI/SizerConfig/Config.js';

let title = ''
const SHARED_ = "Shared";
class CustomArticle extends Component {

  constructor(props) {
    super(props);
    this.state = { contentVisible: true }
    this.onDivClick = this.onDivClick.bind(this);
  }
  onDivClick() {
    this.setState({ contentVisible: !this.state.contentVisible });
  }
  componentWillMount() {
    if (_said === "EPAvNext") {
      this.state.contentVisible = false
    } else {
      this.state.contentVisible = true
    }

  }
  onTitle() {
    if (_said === "EPAvNext") {
      if (this.props.content.props.RoleData !== undefined && this.props.title.indexOf(SHARED_) === -1) {
        //let ServerDetails = []
        let ProcDetails = []
        let MemoryDetails = []
        let Disks = 0
        // ServerDetails=this.props.content.props.RoleData.Processor.split("")
        ProcDetails = this.props.content.props.RoleData.ProcessorDetails.split("C")
        MemoryDetails = this.props.content.props.RoleData.Memory.split("RAM")
        /*Changes by Vinay, Accessing a property and discarding the result, for CID:10691*/
        //this.props.content.props.RoleData.ServerName['@Qty']
        if (this.props.content.props.RoleData.DAS !== "" && this.props.content.props.RoleData.DAS.TableData !== "") {
          if (Array.isArray(this.props.content.props.RoleData.DAS.TableData)) {
            this.props.content.props.RoleData.DAS.TableData.filter((disk) => {
              Disks += parseInt(disk.DiskQty, 10) / parseInt(this.props.content.props.RoleData.ServerName['@Qty'], 10)
            })
          } else {
            Disks += parseInt(this.props.content.props.RoleData.DAS.TableData.DiskQty, 10) / parseInt(this.props.content.props.RoleData.ServerName['@Qty'], 10)
          }
        }
        let Displaytitle = this.props.title
        if (this.props.title === "Storage : HDFS and HDFS-EC") {
          Displaytitle = "Storage : HDFS"
        }
        title = Displaytitle + "  ( " + this.props.content.props.RoleData.Processor + ", " + ProcDetails[0].trim() + "C, " + MemoryDetails[0].trim() + ", " + Disks + " Disks )"
        // this.props.content.props.RoleData.Processor
        // this.props.content.props.RoleData.ProcessorDetails
        // this.props.content.props.RoleData.Memory
        // this.props.content.props.RoleData.DAS.TableData
        //title="Storage: HDFS  ( 19 x HPE Apollo 4200 Gen10, Intel Xeon-S 4214 /12C , 96 GB,  28 Disks)"
      } else {
        title = this.props.title
      }
    } else {
      title = this.props.title
    }
    // title=this.props.title
  }

  render() {
    this.onTitle();
    return (
      <Box colorIndex={this.props.ArticleBackgroundColor} style={{ padding: '5px' }}>
        <Box direction='row' style={{ padding: '5px' }} justify='between' onClick={this.onDivClick} >
          <Box direction='row' pad={{ between: 'small' }} >
            {this.props.titleIcon}
            <Heading tag='h4' strong={true} margin='none' style={{ fontSize: '17px' }}>{title}</Heading>
          </Box>
          {this.state.contentVisible ? <FormUp size='small' /> : <FormDown size='small' />}
        </Box>
        <Animate visible={this.state.contentVisible} keep={false}
          enter={{ "animation": "slide-down", "duration": 200, "delay": 0 }} >
          <Box direction='column' pad='small' colorIndex={this.props.ContentBackgroundColor} >
            {this.props.content}
          </Box>
        </Animate>
      </Box>
    );
  }
}

export default CustomArticle;




// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/CustomArticle.js